export default __webpack_public_path__ + "static/media/dustbin_icon_hover.cf3ef97d.svg";